import React from 'react';
import { baseurl } from '../config/config';
import { leftPad, stringDateTimeDbToDate } from './simpleHelper';

export const appSaveLocale = (locale) => {
    localStorage.setItem('locale', JSON.stringify(locale));
};

export const appGetLocale = () => {
    return appGetLocaleItem()?.locale ?? 'zh-Hant';
};

export const appGetLocaleItem = () => {
    const locale = localStorage.getItem('locale');

    if (locale) {
        return JSON.parse(locale);
    } else {
        return {
            languageId: 'hongkong',
            locale: 'zh-Hant',
            name: 'Hong Kong',
        };
    }
};

export const apiPageOrderObj = ({ page, rowsPerPage, all_pages, orderBy, order }) => {
    return { page, page_size: rowsPerPage, all_pages, order_by: orderBy, order };
};

export const apiFilterSearchObj = ({ filterOptions, debouncedSearchTerm }) => {
    const filters = filterOptions?.map?.((m) => m.value) ?? [];

    return { filters, keywords: debouncedSearchTerm };
};

export const apiPagination = ({ page = 0, page_size = 25, all_pages = false }) => {
    return 'page=' + page + '&size=' + page_size + '&all_pages=' + (all_pages ? 1 : 0);
};

export const apiSorting = ({ order_by = 'id', order = 'asc' }) => {
    return 'order_by=' + order_by + '&order=' + order;
};

export const apiQueryParam = (action) => {
    const { page, page_size, all_pages, order_by, order } = apiPageOrderObj(action);

    const pagination = apiPagination({ page, page_size, all_pages });

    const sort = apiSorting({ order_by, order });

    return pagination + '&' + sort;
};

export const appDateFormat = (date, month_full, ingore_year) => {
    if (!date) return '---';

    const year_full = true;

    if (!(date instanceof Date)) {
        date = new Date(date);
    }
    if (date.toString().includes('T00:00:00.000Z')) {
        date = new Date(date);
    }

    const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];
    let year = year_full ? date.getFullYear() : date.getFullYear().toString().slice(-2);
    let month = date.getMonth();
    let day = date.getDate();

    const locale = appGetLocale();

    if (locale == 'en') {
        month = monthNames[month];
        month = month_full ? month : month.substring(0, 3);
    } else {
        month = month + 1;
    }

    if (locale == 'en') {
        if (!ingore_year) return day + ' ' + month + ' ' + year;
        else return day + ' ' + month;
    } else {
        if (!ingore_year) return year + '年' + month + '月' + day + '日';
        else return month + '月' + day + '日';
    }
};

export const appDateTimeFormat = (date) => {
    if (!date) return '---';

    if (!(date instanceof Date)) {
        return date.toString();
    }
    return appDateFormat(date) + ' ' + appTimeFormat(date);
};

export const appTimeFormat = (date) => {
    if (!date) return '---';

    if (date.toString().includes('T00:00:00.000Z')) {
        date = new Date(date);
    }

    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();

    const locale = appGetLocale();

    if (locale == 'en') {
        return leftPad(hours, 2) + ':' + leftPad(minutes, 2);
    } else if (locale == 'zh-Hans') {
        return leftPad(hours, 2) + '时' + leftPad(minutes, 2) + '分';
    } else {
        return leftPad(hours, 2) + '時' + leftPad(minutes, 2) + '分';
    }
    //return leftPad(hours,2) + ':' + leftPad(minutes,2) + ':' + leftPad(seconds,2)
};

export const appApiDateTimeToDateObj = (date) => {
    if (!date) return null;

    //sample 2018-06-12 16:57:00
    date = date.replace(/-/g, '').replace(/\s/g, '').replace(/:/g, '');
    return stringDateTimeDbToDate(date);
};

export const appDateFormatToApi = (date) => {
    date = new Date(date);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minute = date.getMinutes();
    let second = date.getSeconds();
    return (
        year +
        '-' +
        leftPad(month, 2) +
        '-' +
        leftPad(day, 2) +
        ' ' +
        leftPad(hour, 2) +
        ':' +
        leftPad(minute, 2) +
        ':' +
        leftPad(second, 2)
    );
};
export const appGetLoginInfo = () => {
    try {
        if (global.app_login_info) return global.app_login_info;

        let login_info_json_str = null;

        login_info_json_str = localStorage.getItem('login_info');
        if (login_info_json_str) {
            return JSON.parse(login_info_json_str);
        } else {
            return {};
        }
    } catch (error) {
        return {};
    }
};

export const appSaveLoginInfo = (login_info) => {
    try {
        const login_info_json_str = JSON.stringify(login_info);

        global.app_login_info = login_info;

        localStorage.setItem('login_info', login_info_json_str);
       
        return login_info;
    } catch (error) {
        return login_info;
    }
};

export const appAccessToken = () => {
    const login_info = appGetLoginInfo();
    return login_info?.access_token ?? null;
};

export const appJobNatureDict = () => {
    return {
        baker: 'SHOP_BAKER',
        sales: 'SHOP_SALES',
        logistics: 'LOGISTICS',
        factory: 'FACTORY',
        office: 'OFFICE',
    };
}

export const appPathPrefix = () => {
    return baseurl.path.substring(0, baseurl.path.length-1);
}

export const isMobileAspectRatio = () => {
    const [isMobile, setIsMobile] = React.useState(window.matchMedia("(max-aspect-ratio: 11/9)").matches);

    React.useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.matchMedia("(max-aspect-ratio: 11/9)").matches);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return isMobile;
};